/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Choice_Weekly_QuotaInputs */

const fr_plan_choice_weekly_quota = /** @type {(inputs: Plan_Choice_Weekly_QuotaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} séances par semaine`)
};

/**

* @param {Plan_Choice_Weekly_QuotaInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_weekly_quota = /** @type {((inputs: Plan_Choice_Weekly_QuotaInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Weekly_QuotaInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_weekly_quota(inputs)
});